import { urls } from "../Utils/Urls";
import { Request } from "./Request";
import { TENANT_ID } from "../components/Utils";

/**
 * Build the `entitySearchRequest` envelope every agent farmer-passbook
 * call shares (validateFarmerOtp on entry + farmerPassbookSearch /
 * downloadFarmerPassbook for follow-ups).
 *
 * Originally lived on FarmerPassbookOtpPage; moved here when that page
 * was retired in favour of FarmerContextRoute + usePassbook resource
 * hook. See .agent/rewamp/cta/middleware-refactor-plan.md PR 3.
 */
export const getPayload = ({
  dbtId,
  categoryType,
  additionalFileds = {},
  customSearchCriteria = {},
  additionalPayload = {},
  isSchemesCall = false,
}) => ({
  entitySearchRequest: {
    mobileNumber: null,
    dbtId,
    payload: {
      SearchCriteria: {
        ...(!isSchemesCall
          ? { dbtId, sortBy: "application_date desc" }
          : {}),
        tenantId: TENANT_ID,
        ...customSearchCriteria,
      },
      ...additionalPayload,
    },
    categoryType,
    tenantId: TENANT_ID,
    echoResponse: null,
    ...additionalFileds,
  },
});

export const validateFarmerOtp = async (details) => {
  try {
    const response = await Request({
      url: urls.Agent_Farmer_Search,
      data: { ...details },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const downloadFarmerPassbook = async (payload, onDownloadProgress, signal) => {
  try {
    const response = await Request({
      url: urls.Agent_Farmer_Search,
      data: { ...payload, RequestInfo: { msgId: "20170310130900|en_IN" } },
      responseType: "blob",
      onDownloadProgress,
      signal
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const farmerPassbookSearch = async (details) => {
  try {
    const response = await Request({
      url: urls.Agent_Farmer_Search,
      data: { ...details },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
